import React, { Fragment, useRef, useState } from "react";
import { Button, Form, InputRef, Select, SelectProps, Space } from "antd";
import {
  Controller,
  Control,
  FieldValues,
  PathValue,
  Path,
} from "react-hook-form";
import { InfoIconOutlined, SelectArrow, TickIcon } from "../../CustomIcons";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

let index = 0;

interface SelectFieldProps<T extends FieldValues> {
  fieldName: Path<T>;
  label?: string;
  control: Control<T>;
  defaultValue?: PathValue<T, Path<T>> | undefined;
  iProps?: SelectProps<string | number | readonly string[]>;
  isRequired?: boolean;
  rules?: object;
  validate?: "" | "success" | "warning" | "error" | "validating" | undefined;
  validMessage?: string | React.ReactNode;
  className?: string;
  prefix?: React.ReactNode;
  tooltipTitle?: string | React.ReactNode; // Use ReactNode for tooltip title
  optionalLabel?: string;
  hintMessage?: string;
  warning?: boolean;
  onSelectChange?: (value: string | number | readonly string[]) => void;
  selectOption: { label: string; value: string }[];
  addItemText?: string;
  onAddItemClick?: () => void;
  differentClassName?: string;
}

export const SelectFieldWithButton = <T extends FieldValues>({
  fieldName,
  isRequired = false, // Provide default value
  label,
  validMessage,
  className,
  control,
  defaultValue, // Provide default value
  rules,
  iProps,
  prefix,
  tooltipTitle,
  optionalLabel,
  hintMessage,
  warning,
  validate,
  onSelectChange,
  selectOption,
  addItemText,
  onAddItemClick,
  differentClassName,
}: SelectFieldProps<T>) => {
  const [items, setItems] = useState(["jack", "lucy"]);
  const [name, setName] = useState("");
  const inputRef = useRef<InputRef>(null);

  const addItem = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    if (onAddItemClick) {
      onAddItemClick();
    }
    setItems([...items, name || `New item ${index++}`]);
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <Form.Item
      required={isRequired}
      label={<div className="label_text">{label}</div>}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          placement: "topLeft",
          arrow: false,
          icon: <InfoIconOutlined />,
        }
      }
    >
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <>
            <Select
              suffixIcon={<SelectArrow />}
              {...(iProps && { ...iProps, size: undefined })}
              value={value ?? null}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              optionFilterProp="label"
              prefix={prefix}
              popupClassName={`${differentClassName} option-group-select`}
              onChange={(val) => {
                onChange(val);
                if (onSelectChange) {
                  onSelectChange(val);
                  // const selectedOption = selectOption?.find((opt) =>
                  //   Array.isArray(val)
                  //     ? val?.includes(opt.value)
                  //     : opt.value === val
                  // );

                  // console.log("selectedOption", selectedOption);

                  // if (selectedOption) {
                  //   console.log("val", val);
                  //   onSelectChange(val, selectedOption.label);
                  // }
                }
              }}
              popupRender={(menu) => (
                <div>
                  {menu}
                  <Space
                    style={{
                      padding: "15px 12px 10px 12px",
                      borderRadius: "0px",
                      borderTop: "1px solid rgb(222, 229, 230)",
                      marginTop: "10px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h6
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#474C4D",
                      }}
                    >
                      No property you need? <br /> <span>Add new.</span>
                    </h6>
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addItem}
                      style={{
                        padding: "6px 12px",
                        borderRadius: "10px",
                        border: "1px solid rgb(222, 229, 230)",
                        color: "rgb(21, 23, 24)",
                        fontSize: "13px",
                        fontWeight: 600,
                        marginTop: "10px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {addItemText}
                    </Button>
                  </Space>
                </div>
              )}
            >
              {selectOption?.length > 0 &&
                selectOption?.map(
                  (resp: { label: string; value: string }, i: number) => (
                    <Fragment key={resp?.value + i}>
                      <Option value={resp?.value} label={resp?.label}>
                        <div className="option-label-item">
                          <div className="option_wrap">
                            <span className="role_label">{resp?.label}</span>
                          </div>
                        </div>
                      </Option>
                    </Fragment>
                  )
                )}
            </Select>
            {optionalLabel && (
              <div className="optional-label">{optionalLabel}</div>
            )}
            {hintMessage && (
              <div
                className={warning ? "hint-label warning-label" : "hint-label"}
              >
                {hintMessage}
              </div>
            )}
          </>
        )}
      />
    </Form.Item>
  );
};
